import NBType, { InferType } from '@netbase/nb-type'
import InsightCategorySchema from './InsightCategorySchema'

const InsightCategoryGroupSchema = NBType.object().shape('InsightCategoryGroupSchema', {
  dataset: NBType.array().of(InsightCategorySchema),
  insightGroup: NBType.string()
})

export default InsightCategoryGroupSchema
export type InsightCategoryGroup = InferType<typeof InsightCategoryGroupSchema>
// RESERVE BELOW
